import TurnstileChallenge from '../shared/TurnstileChallenge';
import type { LoginFormProps } from '../../types/authForms';
import { FormTextField, FormPasswordField } from '../molecules/form-elements';
import StyledForm from '../forms/shared/StyledForm';
import { useLoginForm } from '../../hooks/useLoginForm';
import { LOGIN_MODE } from '../../types/enums';

const HybridLoginForm = ({ presentation = 'modal' }: LoginFormProps) => {
  const { t, control, errors, isSubmitting, handleClose, onSubmit, turnstile } = useLoginForm({
    mode: LOGIN_MODE.USERNAME,
    presentation,
  });

  return (
    <StyledForm
      title={t('register.signIn')}
      submitTitle={t('register.signIn')}
      onSubmit={onSubmit}
      onClose={handleClose}
      isSubmitting={isSubmitting}
      submitButton={{ disabled: turnstile?.isReady === false }}
    >
      {turnstile && <TurnstileChallenge {...turnstile.widgetProps} />}
      <FormTextField
        name='username'
        control={control}
        label={t('register.username')}
        variant='outlined'
        fullWidth
        type='text'
        error={!!errors.username}
        helperText={errors.username?.message}
        disabled={isSubmitting}
        autoFocus
      />
      <FormPasswordField
        name='password'
        control={control}
        label={t('register.password')}
        error={!!errors.password}
        helperText={errors.password?.message}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { autoComplete: 'new-password' } }}
      />
    </StyledForm>
  );
};

export default HybridLoginForm;
